import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import { arraysEqual } from '../../utils/comparators';
import {
  fetchEquipForBuildingActionCreator,
  fetchEquipForAllBuildingsActionCreator,
} from '../../redux/actions/equipment';

const mapStateToProps = (state, { org }) => ({
  orgBids: org
    ? Object.values(state?.entities?.buildings?.byId)
        .filter((b) => b.org_id === org.id)
        .map((b) => b.id)
        .toSorted()
    : [],
});

const mapDispatchToProps = (dispatch, { org, buildingId, getPoints, getDevices }) => ({
  hasChangedFunction: (old, next) =>
    old.org !== next.org ||
    old.buildingId !== next.buildingId ||
    !arraysEqual(old.orgBids, next.orgBids),
  fetchFunction: () => {
    if (buildingId)
      dispatch(fetchEquipForBuildingActionCreator(buildingId, getPoints, getDevices)).catch(
        () => {}
      );
    if (org) dispatch(fetchEquipForAllBuildingsActionCreator(org, getPoints, getDevices));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GenericLoader);
